/** Hằng số dùng chung của màn Khách hàng — tách khỏi `TableCustomer` (trước 1231 dòng). */

/** Vai trò là LOẠI, không phải trạng thái -> không tô màu, phân biệt bằng chữ. */
export const CUSTOMER_TYPE_MAP = {
  MANUAL: { label: "Mặc định" },
  CONTRACTOR: { label: "Thợ thầu" },
  DEALER: { label: "Đại lý" },
  // Khách NPP mang customer_type = 'NPP' (migration backfill_npp_customer_type),
  // cột `is_npp` chỉ còn là dấu vết cũ nên không dựa vào nó để ra nhãn.
  NPP: { label: "NPP" },
};

/** Trạng thái tài khoản — khớp accessor `account_state` ở BE (tách trục duyệt & khóa). */
export const ACCOUNT_STATE_MAP = {
  pending: { label: "Chờ duyệt", tone: "warning" },
  active: { label: "Hoạt động", tone: "success" },
  locked: { label: "Đã khóa", tone: "danger" },
  rejected: { label: "Từ chối", tone: "danger" },
  // Khách không có tài khoản đăng nhập (tạo từ luồng không sinh user).
  unknown: { label: "Chưa có tài khoản", tone: "default" },
};

/**
 * Suy trạng thái từ dữ liệu user trả về (approval_status + is_locked).
 *
 * Thiếu `user` thì trả `unknown`, KHÔNG trả `active`: khách không có tài khoản đăng
 * nhập mà hiện "Hoạt động" là nói sai — và trước đây nó còn che luôn trường hợp API
 * không kèm quan hệ `user`, khiến cả cột trạng thái xanh hết.
 */
export const deriveAccountState = (user) => {
  if (!user) return "unknown";
  if (user.approval_status === "PENDING") return "pending";
  if (user.approval_status === "REJECTED") return "rejected";
  return user.is_locked ? "locked" : "active";
};

// `span` là bề rộng cột của ô lọc trong `cms/ListToolbar`.
export const FILTER_DEFS = [
  { key: "branch", label: "Đơn vị", span: { xs: 24, sm: 8 } },
  { key: "customerType", label: "Vai trò", span: { xs: 24, sm: 6 } },
  { key: "status", label: "Trạng thái", span: { xs: 24, sm: 6 } },
  { key: "search", label: "Tìm kiếm", span: { xs: 24, sm: 10 } },
];

export const COLUMN_DEFS = [
  { key: "name", label: "Khách hàng", fixed: true },
  { key: "phone", label: "Số điện thoại" },
  { key: "customer_type", label: "Vai trò" },
  { key: "is_locked", label: "Trạng thái" },
  { key: "email", label: "Email" },
  { key: "birthday", label: "Ngày sinh" },
  { key: "address_info", label: "Địa chỉ chi tiết" },
  { key: "branch_first", label: "Đơn vị" },
  { key: "created_at", label: "Ngày tạo" },
  { key: "operation", label: "Thao tác", fixed: true },
];

export const DEFAULT_VISIBLE_COLUMNS = [
  "name",
  "phone",
  "customer_type",
  "is_locked",
  "birthday",
  "branch_first",
  "operation",
];

/** Đổi một bản ghi API sang dòng bảng. */
export const toRow = (item) => ({
  key: item.id,
  id: item.id,
  name: item?.name,
  avatar: item.avatar,
  phone: item.phone,
  email: item.email,
  branch_first: item?.branch_first?.name,
  birthday: item.birthday,
  address_info: item.address_info,
  created_at: item.created_at,
  // Chỉ có giá trị ở màn Thùng rác (`trashed=1`).
  deleted_at: item.deleted_at,
  customer_type: item.customer_type,
  is_npp: item.is_npp,
  is_locked: item?.user?.is_locked,
  approval_status: item?.user?.approval_status,
  reject_reason: item?.user?.reject_reason,
  account_state: deriveAccountState(item?.user),
});

/** Kiểm tra số điện thoại nhập ở ô tìm kiếm. */
export const validatePhoneNumber = (phone) => {
  if (!phone) return { isValid: true, message: "" };
  const clean = phone.replace(/\D/g, "");
  if (clean.length < 9 || clean.length > 11) {
    return { isValid: false, message: "Số điện thoại phải có 9-11 chữ số" };
  }
  const validPrefixes = ["03", "05", "07", "08", "09", "02", "04", "06", "84"];
  if (!validPrefixes.some((p) => clean.startsWith(p))) {
    return { isValid: false, message: "Số điện thoại không hợp lệ" };
  }
  return { isValid: true, message: "" };
};
